module.exports = __webpack_public_path__ + "img/U1F382.55829ce2.png";